import { type SelectOwnerState } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

import { useProductSearchRefinementContext } from '../ProductSearchRefinement'
import { ProductSearchRefinementClearRefinement } from '../ProductSearchRefinementClearRefinement'

type ProductSearchRefinementCategoryListboxBodyProps<
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
> = ComponentProps<'div'> & {
  ownerState: SelectOwnerState<OptionValue, Multiple>
}

export const ProductSearchRefinementCategoryListboxBody = <
  OptionValue extends NonNullable<unknown>,
  Multiple extends boolean,
>(
  props: ProductSearchRefinementCategoryListboxBodyProps<OptionValue, Multiple>,
): JSX.Element => {
  const {
    children,
    className,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- not used for rendering
    ownerState,
    ...restProps
  } = props

  const refinementContext = useProductSearchRefinementContext()

  if (!('refinementList' in refinementContext)) {
    throw new Error('The refinement is not a list refinement.')
  }

  return (
    <div
      className={clsx(
        className,
        'bg-light-primary-medium desktop:bg-transparent',
      )}
      {...restProps}
    >
      {children}

      <ProductSearchRefinementClearRefinement
        className="hidden self-start desktop:mb-4 desktop:me-4 desktop:ms-6 desktop:mt-6 desktop:inline-flex"
        includedAttributes={[refinementContext.refinementListOptions.attribute]}
      />
    </div>
  )
}
